module.exports = "/restaurants/rest2.jpg?frUotRB";